import { NodeDetailsResponse } from "../../api-models/response/NodeDetailsResponse";
import { NameEntityResponse } from "../../api-models/response/NameEntityResponse";
import { BaseTechnicalInspection } from "../technical-inspection/BaseTechnicalInspection";

export class NodeDetails extends BaseTechnicalInspection {
  id: number;
  name: string;
  dataOwner: string;
  project: NameEntityResponse;
  created: Date;
  modifiedBy: NameEntityResponse;
  createdBy: NameEntityResponse;
  openJobs: number;
  hasGeometry: boolean;
  canDelete: boolean;

  constructor(node?: NodeDetailsResponse) {
    if (node) {
      super(node.dynamicProperties, node.genericIssues);
      this.id = node.id;
      this.name = node.name;
      this.dataOwner = node.dataOwner;
      this.project = node.project;
      this.created = node.created;
      this.modifiedBy = node.modifiedBy;
      this.createdBy = node.createdBy;
      this.openJobs = node.openJobs;
      this.hasGeometry = node.hasGeometry;
      this.canDelete = node.canDelete;
    } else {
      super([], []);
      this.id = 0;
      this.name = "";
      this.dataOwner = "";
      this.project = {
        id: 0,
        name: "",
        isDeleted: false,
      };
      this.created = new Date();
      this.modifiedBy = { id: 0, name: "", isDeleted: false };
      this.createdBy = { id: 0, name: "", isDeleted: false };
      this.openJobs = 0;
      this.hasGeometry = false;
      this.canDelete = false;
    }
  }
}
